// mirror options in this file in api2.providers.processes.plug_template.custom_templates.helpers

export const COST_FIELD_OPTS = {
  0: 'Cost Name', //chargeNameAsPrinted
  1: 'Cost Group Type', //chargeGroupHeading
  2: 'Cost Usage Type', //measurementType
  3: 'Cost Amount', // chargeAmount
  4: 'Contribution Status', //contributionStatus
  5: 'Tariff Provider Name', // tariff.provider.name
};

export const USAGE_FIELD_OPTS = {
  0: 'Usage Name', //usageNameAsPrinted
  1: 'Usage Type', //measurementType
  2: 'Measured Usage', // measuredUsage
  3: 'Cited Usage', //citedUsage
  4: 'Meter Constant Multiplier', //meterConstantMultiplier
  5: 'Contribution Status', //contributionStatus
};

export const COST_VALUE_OPTS = {
  0: 'Cost Amount', //chargeAmount
};

export const USAGE_VALUE_OPTS = {
  0: 'Measured Usage', //measuredUsage
  1: 'Cited Usage', //citedUsage
};

export const COST_LOCATION_OPTS = {
  1: 'Cost 1',
  2: 'Cost 2',
  3: 'Cost 3',
};

export const USAGE_LOCATION_OPTS = {
  1: 'Usage 1',
  2: 'Usage 2',
  3: 'Usage 3',
  4: 'Demand 1',
  5: 'Demand 2',
};

//mirrored as apply_field_name_rules
export const FIELD_NAME_RULE_OPTS = {
  0: 'Equals',
  1: 'Contains',
  2: 'Starts with',
  3: 'Ends with',
  4: 'Is not equal',
  5: 'Does not contain',
  6: 'Is null',
  7: 'Is not null',
};

//mirroed as apply_rule_operation
export const OPERTATION_OPTS = {
  0: 'Add',
  1: 'Subtract',
  2: 'Ignore',
};

export const DEFAULT_TEMPLATE = {
  id: '',
  name: '',
  utility_provider: '',
  usage_default: true,
  cost_default: true,
  has_cost_name: false,
  cost1_name: '',
  cost2_name: '',
  cost3_name: '',
};

export const DEFAULT_RULE = {
  id: null,
  name: '',
  rule_type: '',
  rule_location: 1,
  rule_value: 0,
  operation: 0,
  clauses: [],
};
